export const SESSION_STORAGE_VALUES = {
  hasNewAddressModalAcknowledged: 'newAddressModalAcknowledged',
} as const

export const LOCAL_STORAGE_VALUES = {
  myInfoState: 'myInfoState',
} as const

export const ETH_WITHDRAW_FEES_CAP = {
  biz: {
    oldFee: 1,
    newFee: 30,
  },
  personal: {
    oldFee: 5,
    newFee: 30,
  },
} as const

export const POLYGON_WITHDRAW_FEES_CAP = {
  personal: {
    oldFee: 5,
    newFee: 1,
  },
} as const

export const SUPPORT_LINKS = {
  TRANSFERRING_XSGD:
    'https://support.straitsx.com/hc/en-us/articles/4410444764697-Transferring-XSGD-In',
  WHITELISTING_REQUEST:
    'https://support.straitsx.com/hc/en-us/articles/4410434003993-How-do-I-submit-a-whitelisting-request-for-my-Singapore-based-account',
  SETUP_2FA_LINK:
    'https://support.straitsx.com/hc/en-us/articles/4410444863129-How-to-update-2-Factor-Authentication-2FA-device-or-app',
  WHAT_IS_XSGD: 'https://support.straitsx.com/hc/en-us/articles/4410373376409-What-is-XSGD',
  WHAT_IS_XIDR: 'https://support.straitsx.com/hc/en-us/articles/10744883323929-What-is-XIDR',
}
